var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vuw-progress"},[_c('span',{staticClass:"value",style:({width: (_vm.progressValue + "%")})})])}
var staticRenderFns = []

export { render, staticRenderFns }